import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'app-unauthorized-page',
    imports: [CommonModule, SharedModule, TranslatePipe],
    templateUrl: './unauthorized-page.component.html',
    styleUrl: './unauthorized-page.component.scss'
})
export class UnauthorizedPageComponent {

  constructor(private router: Router) {}

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
